import React from 'react';

/**
 * Inline upgrade prompt for the Company Intel section.
 *
 * FeatureGate's default fallback is a non-dismissible full-page UpgradeModal,
 * which would hijack the whole Portfolio page just because one collapsed
 * section is gated. This is the inline replacement: it explains what's behind
 * the gate and leaves the rest of the page fully usable.
 */
export default function IntelUpgradeNotice() {
  return (
    <div className="pf-inset pf-inset--dashed text-center">
      <div className="text-brand-white font-semibold mb-2">
        Company Intel is a premium feature
      </div>
      <p className="text-sm text-muted mb-4" style={{ maxWidth: '460px', margin: '0 auto 16px' }}>
        Fundamentals, historical financials, EPS estimate trends, fair value, earnings
        history and hedge analysis — for the companies already in your portfolio, without
        retyping a single ticker.
      </p>
      <a href="/pricing" className="btn-primary text-sm" style={{ textDecoration: 'none' }}>
        View plans
      </a>
    </div>
  );
}
